import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RevenueType } from '../models/revenueType.model';
import { RestResponse } from '../models/restResponse.mode';
import { CreateRevenueTypeDto } from '../models/dtos/createRevenueType.dto';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RevenueTypeService {
  private readonly baseUrl = `${environment.base_url}/revenuetypes`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<RestResponse<RevenueType[]>> {
    return this.http.get<RestResponse<RevenueType[]>>(this.baseUrl);
  }

  getActive(): Observable<RestResponse<RevenueType[]>> {
    return this.http.get<RestResponse<RevenueType[]>>(`${this.baseUrl}/active`);
  }

  getById(id: number): Observable<RestResponse<RevenueType>> {
    return this.http.get<RestResponse<RevenueType>>(`${this.baseUrl}/find/${id}`);
  }

  create(revenueType: CreateRevenueTypeDto): Observable<RestResponse<RevenueType>> {
    return this.http.post<RestResponse<RevenueType>>(`${this.baseUrl}/create`, revenueType);
  }

  update(id: number, revenueType: RevenueType): Observable<RestResponse<RevenueType>> {
    return this.http.put<RestResponse<RevenueType>>(`${this.baseUrl}/update/${id}`, revenueType);
  }

  delete(id: number): Observable<RestResponse<object>> {
    return this.http.delete<RestResponse<object>>(`${this.baseUrl}/delete/${id}`);
  }

  list(search: string = '', active?: boolean, page: number = 1): Observable<RestResponse<RevenueType[]>> {
    let params: any = { search, page: page.toString() };
    if (active !== undefined) params.active = active.toString();
    return this.http.get<RestResponse<RevenueType[]>>(`${this.baseUrl}/list`, {
      params
    });
  }
} 